<template>
	<edit></edit>
</template>

<script>
	import edit from './freight_template_edit.vue'
	
	export default {
		components: {
			edit
		}
	}
</script>